"use strict";

angular.module("vendor")
.service("CatalogEntryService", function($resource, FlashBag, $q, $http, appConfig) {
    var catalogEntriesResource = $resource(appConfig.API_SERVER + "/catalog/vendor/catalog-entries/:id/", {id: "@id"}, {
        query: {
            method: "GET",
            isArray: false
        },
        save: {
            method: "POST"
        },
        update: {
            method: "PUT",
            ignoreLoadingBar: true
        },
        patch: {
            method: "PATCH",
            ignoreLoadingBar: true
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });
    var catalogProductAutoComplete = $resource(appConfig.API_SERVER + "/catalog/vendor/products/auto-complete/", {}, {
        query: {
            method: "GET",
            isArray: false,
            ignoreLoadingBar: true
        }
    });

    this.query = function(catalog_id, search, page) {
        var params = {
            search: search,
            page: page,
            catalog: catalog_id
        };
        return catalogEntriesResource.query(params,
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    this.queryProducts = function(catalog_id, search) {
        var params = {
            search: search,
            page: 1,
            catalog: catalog_id
        };
        return catalogProductAutoComplete.query(params,
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    this.create = function(catalog_entry, catalog_id) {
        var params = {
            "catalog": catalog_id,
            "product": catalog_entry.product.id,
            "catalog_entry_variants": catalog_entry.product.product_variants,
            "price": catalog_entry.price,
            "inventory_quantity": catalog_entry.inventory_quantity,
            "packaging_quantity": catalog_entry.packaging_quantity,
            "quantity_min": catalog_entry.quantity_min,
            "quantity_max": catalog_entry.quantity_max
        };
        var catalogEntry = new catalogEntriesResource(params);
        return catalogEntry.$save();
    };

    this.get = function(id) {
        var params = {
            id: id
        };
        return catalogEntriesResource.get(params,
            function onSuccess(data) {
            },
            function onError(response) {
                FlashBag.apiError(response);
            }
        );
    };

    this.patchField = function(id, fieldParam) {
        var params = angular.extend({id: id}, fieldParam);
        var catalogEntry = new catalogEntriesResource(params);
        return catalogEntry.$patch();
    };

    this.delete = function(id) {
        return catalogEntriesResource.delete({id: id}).$promise;
    };

    this.importCatalogEntries = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/catalog-entries/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };

    this.importPromotions = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/promotions/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };

    this.importProductVariants = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/product-variants/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };

    this.importCatalogEntryVariants = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/catalog-entry-variants/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry.service.js
// module id = 877
// module chunks = 0